import { GETMAVGORP } from 'actions/types'
export default (state = [], action) => {
    if (action.type === GETMAVGORP) {
        return action.payload
    }
    return state;
}